module.exports = __webpack_public_path__ + "img/wechat.694736a1.svg";